import { createStyles } from '@mantine/core';
import { DOCUMENTATION_WIDTH } from '../../Documentation/constants.ts';
import { FLOATING_COMMENT_WIDTH } from '../FloatingCommentSidebar/constants';

export const useDocumentationStyles = createStyles(
	(
		theme,
		{
			shouldSetFullWidth,
			showFloatingComments,
		}: {
			shouldSetFullWidth: boolean;
			showFloatingComments: boolean;
		}
	) => {
		const floatingCommentsSidebarWidth = `calc(${FLOATING_COMMENT_WIDTH}px + (2 * ${theme.spacing.md}))`;

		const widthWhenFullWidth = showFloatingComments
			? `calc(100% - ${floatingCommentsSidebarWidth})`
			: '100%';
		const widthWhenCentered = showFloatingComments
			? `calc(${DOCUMENTATION_WIDTH}px + ${floatingCommentsSidebarWidth})`
			: `${DOCUMENTATION_WIDTH}px`;

		return {
			wrapper: {
				margin: '0 auto',
				width: '100%',
				maxWidth: shouldSetFullWidth ? '100%' : widthWhenCentered,
				paddingTop: theme.spacing['3xl'],
			},
			editorContainer: {
				width: '100%',
				maxWidth: shouldSetFullWidth
					? widthWhenFullWidth
					: `${DOCUMENTATION_WIDTH}px`,
				fontSize: theme.fontSizes.sm,
			},
		};
	}
);
